/**
 * Column configuration utilities for SimpleKeywordTabs
 */

import { EnhancedTableColumn } from '@/modules/app/components/ui/table';

export const getColumns = (activeTab: string): EnhancedTableColumn[] => {
  switch (activeTab) {
    case 'serp':
      return [
        { 
          key: 'title', 
          label: 'Title',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
        { 
          key: 'url', 
          label: 'URL',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
        { 
          key: 'description', 
          label: 'Description',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
        { 
          key: 'domain', 
          label: 'Domain',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
      ];
    case 'subtopics':
      return [
        { 
          key: 'subtopic', 
          label: 'Subtopic',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
        { 
          key: 'primary_keyword', 
          label: 'Primary Keyword',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
      ];
    case 'paa':
      return [
        { 
          key: 'people_also_ask', 
          label: 'Question',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
        { 
          key: 'answer', 
          label: 'Answer',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
      ];
    case 'trends':
      return [
        { 
          key: 'primary_keyword', 
          label: 'Keyword',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
        { 
          key: 'search_volume', 
          label: 'Volume',
          filterable: true,
          filterType: 'number',
          sortable: true,
          sortDataType: 'number'
        },
        { 
          key: 'date_from', 
          label: 'From Date',
          filterable: true,
          filterType: 'date',
          sortable: true,
          sortDataType: 'date'
        },
        { 
          key: 'date_to', 
          label: 'To Date',
          filterable: true,
          filterType: 'date',
          sortable: true,
          sortDataType: 'date'
        },
      ];
    case 'autocomplete':
      return [
        { 
          key: 'keyword', 
          label: 'Autocomplete Suggestion',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
        { 
          key: 'rank', 
          label: 'Rank',
          filterable: true,
          filterType: 'number',
          sortable: true,
          sortDataType: 'number'
        },
        { 
          key: 'primary_keyword', 
          label: 'Original Search',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
      ];
    case 'ideas-suggestions':
      return [
        { 
          key: 'data_type', 
          label: 'Source',
          filterable: true,
          filterType: 'select',
          filterOptions: [
            { label: 'Ideas', value: 'ideas' },
            { label: 'Suggestions', value: 'suggestions' }
          ],
          sortable: true,
          sortDataType: 'string'
        },
        { 
          key: 'keyword', 
          label: 'Keyword',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
        { 
          key: 'search_volume', 
          label: 'Volume',
          filterable: true,
          filterType: 'number',
          sortable: true,
          sortDataType: 'number'
        },
        { 
          key: 'intent', 
          label: 'Intent',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
        { 
          key: 'competition', 
          label: 'Competition',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
        { 
          key: 'difficulty', 
          label: 'Difficulty',
          filterable: true,
          filterType: 'number',
          sortable: true,
          sortDataType: 'number'
        },
        { 
          key: 'cpc', 
          label: 'CPC',
          filterable: true,
          filterType: 'number',
          sortable: true,
          sortDataType: 'number'
        },
      ];
    default:
      return [
        { 
          key: 'keyword', 
          label: 'Keyword',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
        { 
          key: 'search_volume', 
          label: 'Volume',
          filterable: true,
          filterType: 'number',
          sortable: true,
          sortDataType: 'number'
        },
        { 
          key: 'intent', 
          label: 'Intent',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
        { 
          key: 'competition', 
          label: 'Competition',
          filterable: true,
          filterType: 'text',
          sortable: true,
          sortDataType: 'string'
        },
        { 
          key: 'difficulty', 
          label: 'Difficulty',
          filterable: true,
          filterType: 'number',
          sortable: true,
          sortDataType: 'number'
        },
        { 
          key: 'cpc', 
          label: 'CPC',
          filterable: true,
          filterType: 'number',
          sortable: true,
          sortDataType: 'number'
        },
      ];
  }
};